import styled from "@emotion/styled";
import { kebabCase } from "change-case";

import {
  FieldColorPicker,
  FormField,
  SkiliticsDuotoneIcon,
  SkiliticsIcon,
  toSpaceCase,
} from "@skilitics/designer-ui-components";
import { useFormatMessage, type FormatMessages } from "@skilitics/localization";

import { FieldCssInput } from "../FieldCssInput";

type BorderPosition = "border" | "borderTop" | "borderBottom" | "borderLeft" | "borderRight";

type Props = {
  borderPosition: BorderPosition;
};

export const BorderInput = ({ borderPosition }: Props) => {
  const formatMessage = useFormatMessage(formatStrings);

  const propertyName = kebabCase(borderPosition);

  return (
    <Row>
      <BorderWidthWrapper>
        <FormField name={`${borderPosition}Width`}>
          <FieldCssInput
            label={getBorderIcon(borderPosition)}
            tooltip={`${toSpaceCase(borderPosition.replace("border", formatMessage("border")))} ${formatMessage("borderWidth")}`}
            placeholder="0px"
            propertyName={propertyName}
          />
        </FormField>
      </BorderWidthWrapper>

      <FormField name={`${borderPosition}Color`}>
        <FieldColorPicker />
      </FormField>
    </Row>
  );
};

const formatStrings = {
  border: {
    en: "Outline",
  },
  borderWidth: {
    en: "Size",
  },
} satisfies FormatMessages;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 5px;
  margin-bottom: 10px;
  font-size: ${({ theme }) => theme.fontSizeSmall};
  line-height: 16px;
`;

const BorderWidthWrapper = styled.div`
  flex: 0 0 65px;
`;

const getBorderIcon = (borderPosition: BorderPosition) => {
  switch (borderPosition) {
    case "border":
      return <SkiliticsIcon icon="outline-thickness" />;
    case "borderTop":
      return <SkiliticsDuotoneIcon icon="side-padding" rotation={90} />;
    case "borderBottom":
      return <SkiliticsDuotoneIcon icon="side-padding" rotation={270} />;
    case "borderRight":
      return <SkiliticsDuotoneIcon icon="side-padding" rotation={180} />;
    case "borderLeft":
      return <SkiliticsDuotoneIcon icon="side-padding" />;
  }
};
